import { startUpgradeProcess } from '@va/dashboard/actions/app';
import { getCurrentPlanName, getFeaturePermissions } from '@va/dashboard/selectors/app';
import { SettingsHeading } from '@va/dashboard/ui/pages';
import { LightIcon } from '@va/icons';
import { useLocale, useTranslate } from '@va/localization';
import { subscriptionStatus } from '@va/standalone/shared/constants';
import { Button, Paragraph, fontWeights } from '@va/ui/design-system';
import { addNumberSeparator } from '@va/util/helpers';
import { WixPermissionPack } from '@va/wix/shared/constants';
import { getPermissionPackage } from '@va/wix/shared/selectors';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

export const UpgradePlanCardWix = () => {
  const translate = useTranslate();
  const { locale } = useLocale();
  const dispatch = useDispatch();
  const currentPlanName = useSelector((state) => getCurrentPlanName(state, subscriptionStatus.ACTIVE));
  const permissions: any = useSelector(getFeaturePermissions);
  const permissionPackage = useSelector(getPermissionPackage);
  const hasPremiumPack = permissionPackage > WixPermissionPack.FREE;

  return (
    <div className='flex flex-col items-start'>
      <SettingsHeading
        title={
          <>
            {translate('featureCounter.currentPlan')}
            <span
              className={classNames('ml-1', {
                'text-green-green': hasPremiumPack,
                'text-orange-dark': !hasPremiumPack,
              })}
            >
              {currentPlanName}
            </span>
          </>
        }
        tooltip={translate('card.currentPlan.wix.tooltip')}
      />
      <div className='flex flex-col'>
        <Paragraph colorClassName='text-gray-dark-charchoal' className='mt-1.5' weight={fontWeights.medium}>
          {translate('card.upgradeBehaviourFeature.text1', {
            currentPlanName: currentPlanName,
            currentRecordingsCount: addNumberSeparator(permissions?.recordings?.limit ?? 0, locale),
            currentHeatmapsCount: addNumberSeparator(permissions?.heatmaps?.limit ?? 0, locale),
            currentFunnelsCount: addNumberSeparator(permissions?.funnels?.limit ?? 0, locale),
            currentPollsCount: addNumberSeparator(permissions?.polls?.limit ?? 0, locale),
            currentSurveysCount: addNumberSeparator(permissions?.surveys?.limit ?? 0, locale),
          })}
        </Paragraph>
        <Button
          className='justify-center mt-18px py-12px'
          icon={() => <LightIcon color={'var(--color-primary)'} />}
          color='secondary'
          text={translate('text.upgradePlan')}
          onClick={() => {
            dispatch(startUpgradeProcess());
          }}
        />
      </div>
    </div>
  );
};
